export default "__VITE_ASSET__c9ac8527__"